import { Api, HttpClient } from "tonapi-sdk-js";
import { message } from "antd";
import copy from "copy-to-clipboard";
const httpClient = new HttpClient({
  baseUrl: "https://tonapi.io",
  baseApiParams: {
    headers: {
      Authorization: `bearer ${"AH5I4JOQ4MJKTJQAAAAFGGK3GGVBH2LGTKW5UKR2GGZI36JMO7XQDMQ6EXHZTM433N6IINA"}`,
      "Content-type": "application/json",
    },
  },
});
export const client = new Api(httpClient);
export function SliceAddress(address: string) {
  let header = address.slice(0, 6);
  let fooler = address.slice(-6);
  return header + "..." + fooler;
}

const copyHandler = (content: string) => {
  copy(content);
  message.success("复制成功");
};

export default copyHandler;
